const chartColors = {
  white: '#fff',
  gray_100: '#f5f5f5',
  gray_200: '#eeeeee',
  gray_300: '#e0e0e0',
  gray_400: '#bdbdbd',
  gray_500: '#9e9e9e',
  gray_600: '#757575',
  gray_700: '#616161',
  gray_800: '#424242',
  gray_900: '#212121',
  black: '#000',

  blue: '#2196f3',
  lightblue: '#6ec6ff',
  darkblue: '#0069c0',
  indigo: '#3f51b5',
  lightindigo: '#757de8',
  darkindigo: '#002984',
  purple: '#9c27b0',
  lightpurple: '#d05ce3',
  darkpurple: '#6a0080',
  pink: '#e91e63',
  lightpink: '#ff6090',
  darkpink: '#b0003a',
  red: '#f44336',
  lightred: '#ff7961',
  darkred: '#ba000d',
  orange: '#ff9800',
  lightorange: '#ffc947',
  darkorange: '#c66900',
  yellow: '#ffeb3b',
  lightyellow: '#ffff72',
  darkyellow: '#c8b900',
  green: '#4caf50',
  lightlight_green: '#bef67a',
  darklight_green: '#5a9216',
  teal: '#009688',
  lightteal: '#52c7b8',
  darkteal: '#00675b',
  cyan: '#00bcd4',
  lightcyan: '#62efff',
  darkcyan: '#008ba3',

  grey: '#9e9e9e',
  lightgrey: '#cfcfcf',
  darkgrey: '#707070',

  deep_purple: '#673ab7',
  light_blue: '#03a9f4',
  light_green: '#8bc34a',
  lime: '#cddc39',
  amber: '#ffc107',
  deep_orange: '#ff5722',
  brown: '#795548',
  blue_grey: '#607d8b',

  lightdeep_purple: '#9a67ea7',
  darkdeep_purple: '#320b86',
  lightlight_blue: '#67daff',
  darklight_blue: '#007ac1',
  lightgreen: '#80e27e',
  darkgreen: '#087f23',
  lightlime: '#ffff6e',
  darklime: '#99aa00',
  lightamber: '#fff350',
  darkamber: '#c79100',
  lightdeep_orange: '#ff8a50',
  darkdeep_orange: '#c41c00',
  lightbrown: '#a98274',
  darkbrown: '#4b2c20',
  lightblue_grey: '#8eacbb',
  darkblue_grey: '#34515e',

  info: '#00bcd4',
  warning: '#ffeb3b',
  danger: '#f44336',
  customwarning: '#ffc107',
  customdanger: '#dc3545',
}

export default chartColors
